module.exports = __webpack_public_path__ + "img/0S6A9837.6880d065.jpg";